import React, { useEffect, useState } from 'react';
import {
  Box, CircularProgress, Container, Typography,
} from '@mui/material';
import Page from '../../components/Layout/Page';
import CustomHeader from '../../components/General/CustomHeader';
import api from '../../requests/api/apiClient';

const PAGE_TITLE = 'Documentación';

const DocumentationView = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;

    api.documentation.grantAccess()
      .then(() => {
        if (mounted) setLoading(false);
      })
      .catch(() => {
        if (mounted) {
          setLoading(false);
          setError(true);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Page title={PAGE_TITLE}>
      <Container maxWidth={false}>
        <CustomHeader title={PAGE_TITLE} />
        {loading && (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Box mt={4}>
            <Typography color="error">
              No se pudo cargar la documentación. Intenta recargar la página.
            </Typography>
          </Box>
        )}
        {!loading && !error && (
          <Box mt={2} height="calc(100vh - 180px)">
            <iframe
              src="/documentacion/index.html"
              title={PAGE_TITLE}
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
};

export default DocumentationView;
